import { gql } from '@apollo/client';

export const GET_ROOM = gql`
  query GET_ROOM($roomId: Float!, $limit: Float, $offset: Float) {
    getRoom(roomId: $roomId, limit: $limit, offset: $offset) {
      __typename
      id
      createdAt
      hasUnreadMessage
      recentMessage
      chatType
      isAccepted

      owner {
        id
        email
        avatar {
          fileUrl
        }
        profile {
          id
          name
        }
      }

      messages {
        id
        content
        createdAt
        readAt
        author {
          id
          email
          avatar {
            fileUrl
          }
        }
        image {
          id
          fileUrl
        }
      }
      members {
        email
        id
        professions {
          name
          id
        }
        avatar {
          fileUrl
        }
        profile {
          id
          name
        }
      }
    }

    getRoomMessageCount(roomId: $roomId)
  }
`;
